// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-containers-index-js": () => import("./../../../src/containers/index.js" /* webpackChunkName: "component---src-containers-index-js" */),
  "component---src-containers-order-js": () => import("./../../../src/containers/order.js" /* webpackChunkName: "component---src-containers-order-js" */),
  "component---src-containers-shopping-cart-js": () => import("./../../../src/containers/shoppingCart.js" /* webpackChunkName: "component---src-containers-shopping-cart-js" */),
  "component---src-templates-product-js": () => import("./../../../src/templates/product.js" /* webpackChunkName: "component---src-templates-product-js" */),
  "component---src-templates-product-type-js": () => import("./../../../src/templates/productType.js" /* webpackChunkName: "component---src-templates-product-type-js" */)
}

